"use strict";

require("core-js/modules/es6.function.bind");

require("core-js/modules/es6.regexp.split");

require("core-js/modules/es6.array.reduce");

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: !0
});

var prismicHelpers = require("prismic-helpers"),
    React = require("react"),
    prismicRichtext = require("prismic-richtext"),
    chooseElement = function chooseElement(e, t, r, i, a) {
  return a ? React.createElement(a, {
    key: i
  }, r) : serializeStandardTag(e, t, r, i);
};

function serialize(e, t, r, i, a, n, s) {
  var c = Object.assign({}, e);

  switch (r) {
    case prismicRichtext.Elements.heading1:
      return chooseElement("h1", i, n, s, c.heading1);

    case prismicRichtext.Elements.heading2:
      return chooseElement("h2", i, n, s, c.heading2);

    case prismicRichtext.Elements.heading3:
      return chooseElement("h3", i, n, s, c.heading3);

    case prismicRichtext.Elements.heading4:
      return chooseElement("h4", i, n, s, c.heading4);

    case prismicRichtext.Elements.heading5:
      return chooseElement("h5", i, n, s, c.heading5);

    case prismicRichtext.Elements.heading6:
      return chooseElement("h6", i, n, s, c.heading6);

    case prismicRichtext.Elements.paragraph:
      return chooseElement("p", i, n, s, c.paragraph);

    case prismicRichtext.Elements.preformatted:
      return chooseElement("pre", i, n, s, c.preformatted);

    case prismicRichtext.Elements.strong:
      return chooseElement("strong", i, n, s, c.strong);

    case prismicRichtext.Elements.em:
      return chooseElement("em", i, n, s, c.em);

    case prismicRichtext.Elements.listItem:
      return chooseElement("li", i, n, s, c.listItem);

    case prismicRichtext.Elements.oListItem:
      return chooseElement("li", i, n, s, c.oListItem);

    case prismicRichtext.Elements.list:
      return chooseElement("ul", i, n, s, c.list);

    case prismicRichtext.Elements.oList:
      return chooseElement("ol", i, n, s, c.oList);

    case prismicRichtext.Elements.image:
      return serializeImage(t, i, s, c.image);

    case prismicRichtext.Elements.embed:
      return serializeEmbed(i, s, c.embed);

    case prismicRichtext.Elements.hyperlink:
      return serializeHyperlink(t, i, n, s, c.hyperlink);

    case prismicRichtext.Elements.label:
      return serializeLabel(i, n, s, c.label);

    case prismicRichtext.Elements.span:
      return serializeSpan(a);

    default:
      return null;
  }
}

function propsWithUniqueKey(e, t) {
  return Object.assign({}, e || {}, {
    key: t
  });
}

function serializeStandardTag(e, t, r, i) {
  var a = t.label ? {
    className: t.label
  } : {};
  return React.createElement(e, propsWithUniqueKey(a, i), r);
}

function serializeHyperlink(e, t, r, i, a) {
  var n = t.data.target ? {
    target: t.data.target
  } : {},
      s = t.data.target ? {
    rel: "noopener"
  } : {},
      c = Object.assign({
    href: prismicHelpers.Link.url(t.data, e)
  }, n, s);
  return a ? React.createElement(a, Object.assign({
    key: i
  }, c), r) : React.createElement("a", propsWithUniqueKey(c, i), r);
}

function serializeLabel(e, t, r, i) {
  var a = e.data ? {
    className: e.data.label
  } : {};
  return i ? React.createElement(i, Object.assign({
    key: r
  }, a), t) : React.createElement("span", propsWithUniqueKey(a, r), t);
}

function serializeSpan(e) {
  return e ? e.split("\n").reduce(function (e, t) {
    if (0 === e.length) return [t];
    var r = (e.length + 1) / 2 - 1,
        i = React.createElement("br", propsWithUniqueKey({}, r));
    return e.concat([i, t]);
  }, []) : null;
}

function serializeImage(e, t, r, i) {
  var a,
      n = t.linkTo ? prismicHelpers.Link.url(t.linkTo, e) : null,
      s = t.linkTo && t.linkTo.target ? {
    target: t.linkTo.target
  } : {},
      c = s.target ? {
    rel: "noopener"
  } : {};
  return a = i ? React.createElement(i, {
    src: t.url,
    alt: t.alt || ""
  }) : React.createElement("img", {
    src: t.url,
    alt: t.alt || ""
  }), React.createElement("p", propsWithUniqueKey({
    className: [t.label || "", "block-img"].join(" ")
  }, r), n ? React.createElement("a", Object.assign({
    href: n
  }, s, c), a) : a);
}

function serializeEmbed(e, t, r) {
  var i,
      a = Object.assign({
    "data-oembed": e.oembed.embed_url,
    "data-oembed-type": e.oembed.type,
    "data-oembed-provider": e.oembed.provider_name
  }, e.label ? {
    className: e.label
  } : {});
  return i = r ? React.createElement(r, {
    key: t
  }) : React.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: e.oembed.html
    }
  }), React.createElement("div", propsWithUniqueKey(a, t), i);
}

var RichTextRenderer = {
  asText: function asText(e) {
    return prismicRichtext.asText(e);
  },
  render: function render(e, t, r, i) {
    var a = prismicRichtext.serialize(e, serialize.bind(null, t, r), i);
    return React.createElement(React.Fragment, {}, a);
  },
  Elements: prismicRichtext.Elements
},
    RichText = function RichText(e) {
  return RichTextRenderer.render(e.richText, {
    heading1: e.heading1,
    heading2: e.heading2,
    heading3: e.heading3,
    heading4: e.heading4,
    heading5: e.heading5,
    heading6: e.heading6,
    paragraph: e.paragraph,
    strong: e.strong,
    em: e.em,
    listItem: e.listItem,
    oListItem: e.oListItem,
    list: e.list,
    oList: e.oList,
    image: e.image,
    embed: e.embed,
    hyperlink: e.hyperlink,
    label: e.label,
    span: e.span
  }, e.linkResolver, e.htmlSerializer);
};

exports.Date = prismicHelpers.Date, exports.Link = prismicHelpers.Link, exports.RichTextRenderer = RichTextRenderer, exports.RichText = RichText;